import { render } from "./infoColumnComponent.vue?vue&type=template&id=345d87ec&scoped=true"
import script from "./infoColumnComponent.vue?vue&type=script&lang=js"
export * from "./infoColumnComponent.vue?vue&type=script&lang=js"

import "./infoColumnComponent.vue?vue&type=style&index=0&id=345d87ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345d87ec"]])

export default __exports__